import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import PaymentTypeModel, { CreatePaymentTypeModel, UpdatePaymentTypeModel } from "../../../viewModels/Dictionaries/PaymentTypeModel";
import SortObject from "../../../types/SortObject";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  paymentTypes: Array<PaymentTypeModel>;
  total: number;
  pageSize: number;
  page: number;
  sort?: SortObject;
  searchFilterValue: string;
  paymentTypeIdToEdit?: number;
  isEditDrawerLoading: boolean;
  isEditDrawerOpen: boolean;
} = {
  loading: true,
  loadingData: true,
  paymentTypes: undefined!,
  total: undefined!,
  pageSize: 10,
  page: 1,
  searchFilterValue: "",
  isEditDrawerLoading: false,
  isEditDrawerOpen: false,
};

const paymentTypesSlice = createSlice({
  name: "paymentTypes",
  initialState,
  reducers: {
    loadPaymentTypes(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadPaymentTypesSuccess(state, action: PayloadAction<{ paymentTypes: Array<PaymentTypeModel>; total: number }>) {
      state.loading = false;
      state.loadingData = false;
      state.paymentTypes = action.payload.paymentTypes;
      state.total = action.payload.total;
    },
    loadPaymentTypesError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },
    changeSearchFilterValue(state, action: PayloadAction<string>) {
      state.searchFilterValue = action.payload;
    },
    search(state) {
      state.loadingData = true;
      state.page = 1;
    },
    openEditDrawer(state, action: PayloadAction<number | undefined>) {
      state.paymentTypeIdToEdit = action.payload!;
      state.isEditDrawerOpen = true;
    },
    closeEditDrawer(state) {
      if (!state.isEditDrawerLoading) {
        state.paymentTypeIdToEdit = undefined!;
        state.isEditDrawerOpen = false;
      }
    },
    createPaymentType(state, _action: PayloadAction<CreatePaymentTypeModel>) {
      state.isEditDrawerLoading = true;
    },
    createPaymentTypeSuccess(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },
    createPaymentTypeError(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },
    updatePaymentType(state, _action: PayloadAction<UpdatePaymentTypeModel>) {
      state.isEditDrawerLoading = true;
    },
    updatePaymentTypeSuccess(state, action: PayloadAction<UpdatePaymentTypeModel>) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
      const index = state.paymentTypes.findIndex((item) => item.id === action.payload.id);
      state.paymentTypes[index] = action.payload;
    },
    updatePaymentTypeError(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },
    deletePaymentType(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
  },
});

export default paymentTypesSlice;
